import React from 'react'
import PropTypes from 'prop-types'
import { bindAll } from 'lodash-es'
import classnames from 'classnames'

import { ModalComponent } from '..'

import './ConfirmComponent.scss'

class ConfirmComponent extends React.Component {
  constructor() {
    super()

    this.state = { visible: false }

    bindAll(this, 'toggleConfirmModal', 'handleOkClick')
  }

  handleOkClick(e) {
    const { stopPropagation, preventDefault, onConfirm } = this.props

    if (e && preventDefault) {
      e.preventDefault()
    }

    if (e && stopPropagation) {
      e.stopPropagation()
    }

    this.toggleConfirmModal()
    onConfirm()
  }

  getClassNames() {
    const { className: classes } = this.props
    return classnames('confirm-component', { [classes]: classes })
  }

  toggleConfirmModal(e) {
    const { stopPropagation, preventDefault } = this.props

    if (e && stopPropagation) {
      e.stopPropagation()
    }

    if (e && preventDefault) {
      e.preventDefault()
    }

    this.setState((state) => ({ visible: !state.visible }))
  }

  renderButton() {
    const { children } = this.props

    return React.cloneElement(React.Children.only(children), {
      onClick: this.toggleConfirmModal,
    })
  }

  render() {
    const { visible } = this.state
    const { okText, confirmText, okButtonProps, cancelText } = this.props

    return (
      <div className={this.getClassNames()}>
        {this.renderButton()}
        <ModalComponent
          showFooter
          closable={false}
          visible={visible}
          onOk={this.handleOkClick}
          okText={okText}
          onCancel={this.toggleConfirmModal}
          cancelText={cancelText}
          okButtonProps={okButtonProps}
          wrapClassName="confirm-component-modal"
        >
          <div className="confirm-component-title">{confirmText}</div>
        </ModalComponent>
      </div>
    )
  }
}

ConfirmComponent.propTypes = {
  confirmText: PropTypes.node,
  children: PropTypes.node,
  okText: PropTypes.string,
  onConfirm: PropTypes.func,
  className: PropTypes.string,
  stopPropagation: PropTypes.bool,
  preventDefault: PropTypes.bool,
  okButtonProps: PropTypes.object,
  cancelText: PropTypes.string,
}

ConfirmComponent.defaultProps = {
  confirmText: 'Are you sure you want to delete this item?',
  okText: 'Delete',
  className: '',
  okButtonProps: {},
}

export default ConfirmComponent
